import {
  getString,
} from "@surya-digital/leo-ts-types";

export interface RespondentNameDTO {
  name: string;
}

export class RespondentName {
  readonly isRespondentNameRespondentName: boolean = true;

  readonly name: string;

  static readonly constraints = {
    "name": {
      "maxSize": 200,
      
      
      
      
    }
  }

  constructor(
  name: string
  ) {
    RespondentName.validateName(name);
    this.name = name;
  }

  static fromDTO(dto: RespondentNameDTO): RespondentName {
    const name = getString(dto, "name", InvalidRespondentNameNameError);
    return new RespondentName(
      name
    );
  }

  toDTO(): RespondentNameDTO {
    const dto: RespondentNameDTO = {
        name: this.name
    };
    return dto;
  }
  private static validateName = (name: string): void => {
    if(name.length > 200) {
      throw new InvalidRespondentNameNameMaxSizeError(
        200,
        `Attribute name is too long. Size is ${name.length}. Max size is 200.`
      );
    }
      if(name.trim().length === 0) {
        throw new InvalidRespondentNameNameNonEmptyError(
          `Attribute name cannot be an empty string.`
        );
      }
  }
  
}

RespondentName.prototype.toString = function toString(): string {
  return `RespondentName(name='${this.name}')`;
};

export class InvalidRespondentNameError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentNameError";
  }
}
export class InvalidRespondentNameNameError extends InvalidRespondentNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentNameNameError";
  }
}

export class InvalidRespondentNameNameMaxSizeError extends InvalidRespondentNameNameError {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentNameNameMaxSizeError";
  }
}

export class InvalidRespondentNameNameNonEmptyError extends InvalidRespondentNameNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentNameNameNonEmptyError";
  }
}
